import language from './lang/index.js';

const DEFAULT = 'en';
let l10n = {
  _curr: DEFAULT,
  _translation: {},
  set translation(lang) {
    if (typeof lang !== 'string') {
      this._translation = lang; // translations object;
      this._curr = '';
    } else if (!language[lang]) {
      this._translation = language[DEFAULT] || {};
      this._curr = lang;
    } else {
      this._translation = language[lang];
      this._curr = lang;
    }
  },
  get translation() {
    return this._translation;
  }
};
function setLanguage(lang) {
  l10n.translation = lang || DEFAULT || {};
}
function setManualL10n(localizationCtx) {
  l10n.translation = localizationCtx;
}
function getTranslationStr(key) {
  let fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return l10n.translation[key] || fallback || language[DEFAULT][key] || key;
}
var localization = {
  getTranslationStr
};

export { localization as default, getTranslationStr, l10n, setLanguage, setManualL10n };
